import { View } from "@-/com.npmjs.react-native";
import Animated from "@-/com.npmjs.react-native-reanimated";
import { PrimaryControlsStripExpansionHost } from "#primary-controls-strip-expansion";
import { usePrimaryControlsStripExpansionAnimatedHeight } from "#use-primary-controls-strip-expansion-animated-height";

/**
 * Standalone slide-down panel for the expansion content, decoupled from `PrimaryControlsStrip`.
 *
 * Used in native landscape, where the expand/collapse toggle lives in the sidebar but the
 * content should drop down over the scene to the right of the sidebar (anchored under the
 * top safe-area bar) rather than pushing the sidebar's own header. The shared expanded flag
 * and the height animation live in `usePrimaryControlsStripExpansionAnimatedHeight`, so the sidebar
 * toggle drives this panel and the in-header strip identically.
 *
 * The content stays mounted unconditionally so toggling doesn't remount the subtree and
 * flash default state; the hook measures its intrinsic height via an `onLayout` probe and
 * animates the wrapper between 0 and that height. Wrapper `overflow:hidden` clips during the
 * animation.
 */
export function PrimaryControlsStripExpansionPanel({ className = "" }: { className?: string }) {
  const { onContentLayout, wrapperStyle } = usePrimaryControlsStripExpansionAnimatedHeight();

  return (
    <Animated.View
      className={`relative overflow-hidden bg-background ${className ?? ""}`}
      style={wrapperStyle}
    >
      <View className="absolute inset-x-0 px-3" onLayout={onContentLayout}>
        <PrimaryControlsStripExpansionHost />
      </View>
    </Animated.View>
  );
}
